
import Highcharts from 'highcharts';
import HighchartsReact from "highcharts-react-official";


export default function ColumnChartDias({
  series,
  title
}: {
    series: any,
    title: string
}) {

  const options = {
    chart: {
      type: "column"
    },
    title: {
      text: title
    },
    xAxis: {
      categories: series && series.categoria ? series.categoria.categories : []
    },
    yAxis: {
      title: { text: 'Quantidade' },
      allowDecimals: false,
      labels: {
        formatter: function (e: any): string {
          return '' + e.value;
        }
      }
    },
    credits: {
      enabled: false
    },
    series: series ? series.series : []
  };

  return (
    <HighchartsReact highcharts={Highcharts} options={options} />
  )
}
